import { environment } from '@env/environment';
import { IGtmArgs } from '@shared/interfaces/IGtmArgs.interface';
import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { TrackingScripts } from '@shared/helpers/tracking.scripts';

declare let dataLayer: any;

@Injectable({ providedIn: 'root' })
export class TrackingService {

  constructor(
    @Inject(DOCUMENT) private document: any,
  ) {
    TrackingScripts.setGtmScript(environment.gtm, this.document);
  }

  setDataLayerAttributes(data: any) {
    this.sendDataLayerEvent(data);
  }

  private sendDataLayerEvent(data: IGtmArgs) {
    if (typeof (dataLayer) === 'undefined') {
      return;
    }

    dataLayer.push(data);
  }

}
